<div class="stepper-body">
    <div class="body-title">
        <span>What is your ideal purchase price?</span>
    </div>
    <div class="body-description">
        <span>It’s fine to use a general estimate for now, reflecting the homes you're considering.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <span matPrefix>$&nbsp;</span>
                        <input matInput currencyMask [options]="currencyOptions" [formControlName]="PurchasePriceInputs.PurchasePrice" [required]="true" />
                        <mat-error *ngIf="formGroup.get(PurchasePriceInputs.PurchasePrice)?.touched
                                        && formGroup.get(PurchasePriceInputs.PurchasePrice)?.hasError('required')">
                            {{ PurchasePriceInputs.PurchasePrice }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()"
            class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>